import { render, staticRenderFns } from "./SDAInvDialog.vue?vue&type=template&id=2d50eb56&scoped=true"
import script from "./SDAInvDialog.vue?vue&type=script&lang=js"
export * from "./SDAInvDialog.vue?vue&type=script&lang=js"
import style0 from "./SDAInvDialog.vue?vue&type=style&index=0&id=2d50eb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d50eb56",
  null
  
)

export default component.exports